import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import getTempRangeDisplay from './getTempRangeDisplay'
import serverTimestamp from '../../utilities/Data/serverTimestamp'
import ButtonWithIcon from '../ButtonWithIcon'
import weatherTypes from '../../enums/weatherTypes'
import styles from './PostTitleConditions.icss'

const cap = str => str.charAt(0).toUpperCase() + str.slice(1)

const getWeatherIcons = post => Object.keys(weatherTypes).map(wt => (post[wt] ? (
	<ButtonWithIcon
		key={wt}
		smallerButtons
		iconName={`black${cap(wt)}`}
		fullWidth={false}
		classes={{ root: styles.buttonRoot, label: styles.buttonLabel }}
		className={styles.button}
	/>
) :
	undefined)).filter(icon => !!icon)

class PostTitleConditions extends Component {
	render() {
		const { post, url } = this.props
		const weatherIcons = getWeatherIcons(post)
		const range = getTempRangeDisplay(post)
		const showAlternativeTitle = !range && weatherIcons.length === 0
		const altTitle = moment(serverTimestamp(post.dateTimestamp)).format('ddd Do MMM')
		return showAlternativeTitle ? altTitle : (
			<>
				{url ? (
					<Link className={styles.link} to={url}>
						{range && <span className={styles.range}>{range}</span>}
						<span>{weatherIcons}</span>
					</Link>
				) : (
					<span className={styles.link}>
						{range && <span className={styles.range}>{range}</span>}
						<span>{weatherIcons}</span>
					</span>
				)}
			</>
		)
	}
}

PostTitleConditions.contextTypes = {
	translate: PropTypes.func
}

PostTitleConditions.propTypes = {
	post: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	url: PropTypes.string
}

PostTitleConditions.defaultProps = {
	post: undefined,
	url: undefined
}

export default PostTitleConditions



// WEBPACK FOOTER //
// ./src/components/Item/PostTitleConditions.jsx